import { useEffect, useState } from "react";

export function useEnLinea(): boolean {
  const [ok, setOk] = useState(() => (typeof navigator === "undefined" ? true : navigator.onLine));
  useEffect(() => {
    const on = () => setOk(true);
    const off = () => setOk(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);
  return ok;
}
